import { defineComponent as _defineComponent } from 'vue'
import { Device } from '@/models/device';
import ClickMenu from '@/components/menu/ClickMenu.vue';
import { MachineType } from '@/models/enums/MachineType';
import { Shift } from '@/models/shift';
import { isEmpty, isNil } from '@/utils/misc';
import { devicesService } from '@/services/devices.service';
import { shiftsService } from '@/services/shifts.service';
import { areArraysEqual } from '@/utils/array';
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ShiftFilter',
  props: {
    value: null,
    selectedDeviceIds: null,
    machineType: null,
    position: { default: 'is-bottom-left' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: number[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number[], selectedDeviceIds: string[], machineType?: MachineType, position: string };





const { t } = useI18n();

const deviceIdDhs = ref<string[]>([]);

onMounted(() => {
  loadDeviceIdDhs();
});

function emitInput(value: (number | string)[] | number | string) {
  emit('input', value as number[]);
}

function loadDeviceIdDhs() {
  deviceIdDhs.value = isEmpty(props.selectedDeviceIds)
    ? devicesService.store
        .getAll()
        .filter(
          (device: Device) =>
            !isNil(props.machineType) &&
            Device.GetMachineType(device) === props.machineType,
        )
        .map((x: Device) => x.deviceId)
    : props.selectedDeviceIds;
}

const shifts = computed((): Shift[] =>
  shiftsService.store.getAllByDeviceIds(deviceIdDhs.value),
);
const shiftNumbers = computed((): number[] =>
  shifts.value.map((shift: Shift) => shift.id),
);
const shiftNames = computed((): string[] =>
  shifts.value.map((shift: Shift) => shift.name),
);

watch(
  () => props.selectedDeviceIds,
  (newValue: string[], oldValue: string[]) => {
    if (!areArraysEqual(oldValue, newValue)) {
      loadDeviceIdDhs();
      const newShiftIds = shifts.value.map((shift) => shift.id);
      emit(
        'input',
        props.value.filter((selectedShiftId) =>
          newShiftIds.includes(selectedShiftId),
        ),
      );
    }
  },
  { deep: true },
);

return { __sfc: true,props, emit, t, deviceIdDhs, emitInput, loadDeviceIdDhs, shifts, shiftNumbers, shiftNames, ClickMenu, isEmpty }
}

})